// extracted by mini-css-extract-plugin
export default {"DownloadButton":"_DownloadButton--dZbf0"};